import { OctGenerateForm } from '@oceantech/oceantech-ui';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import useFormio from 'src/app/hook/useFormio';
import { CODE, CODE_GENERATE_FORM, TERM_CLASS_IDS } from 'src/app/modules/utils/Constant';
import { searchTerms } from 'src/app/modules/utils/ServicesUtils';
import CustomComponent from './CustomComponent';

const AdditionalInfo = ({ isView }: any) => {
	const { formJSON } = useFormio({
		code: CODE_GENERATE_FORM.tiepDonThongTinBoSung,
	});
	const { values, setFieldValue } = useFormikContext<any>();
	const [filteredICD10List, setFilteredICD10List] = useState([]);

	useEffect(() => {
		if (Object.keys(formJSON).length) {
			getfilteredICD10List();
		}
	}, [formJSON]);

	const getfilteredICD10List = async () => {
		try {
			const { code, data } = await searchTerms(TERM_CLASS_IDS.ICD10, {
				isReferralExempt: 'true',
			});

			if (CODE.SUCCESS === code) {
				setFilteredICD10List(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<OctGenerateForm
			listFieldAuto={formJSON}
			values={values}
			setFieldValue={setFieldValue}
			modelID="additionalInfo"
			customComponent={CustomComponent}
			customProps={{
				filteredICD10List,
			}}
			isView={isView}
		/>
	);
};

export default AdditionalInfo;
